import React, { useEffect, useState } from "react";
import { PhoneNumberInput } from "@client/shared/components";
import { globalStyles, noop, VALIDATIONS } from "@client/shared/constants";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import style from "./style";
import Alert from '@mui/material/Alert';

let isPhoneInputFocused = false;
const defaultState = {
  errors: {
    callToRecordVoicemailNumber: " ",
    callToRecordVoicemailTitle: " ",
  }
};
const CallToRecordView = ({
  callToRecordVoicemailNumber = null,
  callToRecordVoicemailTitle = "",
  phoneNumberList = [],
  countryList = [],
  ringoutId = null,
  recievingVoicemail = false,
  makeRingoutCall = noop,
  handleChange = noop,
  cancelCall = noop,
  phoneNumberError = null,
  isPhoneNumberParsed = false,
  isParsingPhoneNumber = false,
  onPhoneNumberChange = noop,
  parsePhoneNumber = noop,
  voicemailList = [],
}) => {
  
  const [state, setState] = useState(defaultState);
  useEffect(() => {
    return () => {
      isPhoneInputFocused = false;
    }
  }, []);
  const isPhoneInputDisabled = !!(isParsingPhoneNumber || ringoutId || recievingVoicemail);
  return (
    <Box
      sx={{
        mt: 4,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          mb: 1,
          ...globalStyles.text.weight.bold,
        }}
      >
        Call to Record
      </Typography>
      <Box
        sx={{
          mt: 2,
        }}
      >
        <Box
          sx={{
            ...globalStyles.display.flex,
            ...globalStyles.flex.justify.between,
            mt: 2,
          }}
        >
          <Box
            sx={{
              mr: 1,
              ...globalStyles.width["55"],
              ...(isPhoneInputDisabled ? {
                  pointerEvents: 'none',
                  '& *': {
                    color: 'grey.400' 
                  }
                } : {})
            }}
          >
            <PhoneNumberInput
              classes={{
                list: {
                  '& .MuiMenu-paper': {
                    maxHeight: 300,
                    maxWidth: 300,
                  },
                },
              }}
              isLoading={isParsingPhoneNumber}
              disabled={isPhoneInputDisabled}
              value={callToRecordVoicemailNumber}
              options={countryList}
              onChange={onPhoneNumberChange}
              onFocus={() => {
                isPhoneInputFocused = true;
              }}
              validations={{
                [VALIDATIONS.REQUIRED]: true,
                [VALIDATIONS.MIN_LENGTH]: 3,
              }}
              error={isPhoneInputFocused ? (phoneNumberError || ' ') : ' '}
              onBlur={event => {
                if ((callToRecordVoicemailNumber || "").length < 3 || !!phoneNumberError) {
                  return;
                }
                parsePhoneNumber();
              }}
            />
          </Box>
          <TextField
            disabled={ringoutId || recievingVoicemail}
            size="small"
            placeholder="Add Title..."
            name="callToRecordVoicemailTitle"
            value={callToRecordVoicemailTitle}
            onChange={evt => {
              const { name, value }= evt.currentTarget;
              handleChange(evt);
              const existingFileNames = voicemailList.map(item => {
                const fileName = (item.filename || "").split(".");
                fileName.pop();
                return (fileName.join(".") || "").trim().toLowerCase();
              });
              const isFileNameExist = existingFileNames.includes((value || "").trim().toLocaleLowerCase());
              setState(prevState => ({
                ...prevState,
                errors: {
                  ...prevState.errors,
                  [name]: !value ? "Required" : (isFileNameExist ? "File already exist with same name" : " "),
                }
              }));
            }}
            sx={{
              ...globalStyles.width["50"],
            }}
            helperText={state.errors.callToRecordVoicemailTitle}
            error={!!(state.errors.callToRecordVoicemailTitle || "").trim()}
          />
        </Box>
        <Alert sx={{ my: 1 }} severity="warning">
          Note: Call to record feature will not work on softphones. It will work only on physical device (landline, mobile phone)
        </Alert>
        <Box
          sx={{
            ...globalStyles.display.flex,
            ...globalStyles.flex.justify.end,
            ...globalStyles.flex.align.center,
            mt: 1,
          }}
        >
          {(ringoutId || recievingVoicemail) && (
            <>
              <Typography variant="body2" sx={{ mr: 2 }}>
                {recievingVoicemail ? "Recieving..." : "Call in progress..."}
              </Typography>
              {recievingVoicemail ? (
                <CircularProgress
                  size={20}
                  sx={{ mr: 1, ...style.recievingLoader }}
                />
              ) : (
                <img alt="Calling" src="/assets/calling.gif" />
              )}
            </>
          )}
          <Button
            disabled={
              (state.errors.callToRecordVoicemailNumber || '').trim() ||
              (state.errors.callToRecordVoicemailTitle || '').trim() ||
              !!phoneNumberError ||
              !isPhoneNumberParsed ||
              !(callToRecordVoicemailNumber && callToRecordVoicemailTitle) ||
              recievingVoicemail ||
              !(callToRecordVoicemailTitle || "").trim()
            }
            variant="contained"
            startIcon={
              <img src="/assets/call.svg" alt="svg" width={18} height={18} />
            }
            onClick={() =>
              ringoutId
                ? cancelCall()
                : makeRingoutCall(callToRecordVoicemailNumber)
            }
            sx={{
              ...(ringoutId ? style.cancelCall : {}),
            }}
          >
            {ringoutId ? "Cancel" : "Call Now"}
          </Button>
        </Box>
        {(ringoutId || recievingVoicemail) && (
          <Alert sx={{ mt: 2 }} severity="warning">
            Please do not press back, reload or close the page until recording is complete.
          </Alert>
        )}
      </Box>
    </Box>
  );
};

export default CallToRecordView;
